const initialState = {
    responseFacturacion: [],
    responseHashExportFacturacion: [],
    responseCheckReportFacturacion: [],
    responseInvoicesList:[],
    responseInvoice:[],

    errorFacturacion: false,
    errorHashExportFacturacion: false,
    errorCheckReporFacturacion: false,
    errorInvoices: false,
    errorInvoice: false
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "FACTURACION_RESPONSE":
            newState.responseFacturacion = action.value;
            break;
        case 'HASH_EXPORT_FACTURACION_RESPONSE':
            newState.responseHashExportFacturacion = action.value;
            if (action.value.detail !== undefined) {
                newState.errorHashExportFacturacion = true;
            } else {
                newState.errorHashExportFacturacion = false;
            }
            break;
        case 'REPORT_EXPORT_FACTURACION_RESPONSE':
            newState.responseCheckReportFacturacion = action.value;
            if (action.value.detail !== undefined) {
                newState.errorCheckReporFacturacion = true;
            } else {
                newState.errorCheckReporFacturacion = false;
            }
            break;
        case "INVOICES_LIST_RESPONSE":
            newState.responseInvoicesList = action.value
            if ((action.value.detail !== undefined) || (action.value.status === 404)) {
                newState.errorInvoices = true;
            } else {
                newState.errorInvoices = false;
            }
            break;
        case "INVOICE_RESPONSE":
            newState.responseInvoice = action.value;
            if ((action.value.detail !== undefined) || (action.value.status === 404)) {
                newState.errorInvoice = true;
            } else {
                newState.errorInvoice = false;
            }
        default:
            return newState;
    }

    //Posibles errores
    if (action.value.detail !== undefined) {

        newState.errorFacturacion = true;
        newState.responseFacturacion.detail = {}
    } else {
        newState.errorFacturacion = false;
    }
    return newState;
};

export default reducer;